import { marketIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";
import { null as zNull } from "zod";

// 404 when the market isn't owned by the team (don't confirm existence).
export const deleteMarket = {
  name: "deleteMarket" as const,
  input: z.object({
    marketId: marketIdFormat.schema,
    shopifyMarketDisposition: z.enum(["orphan", "delete"]).default("delete"),
  }),
  output: zNull(),
};
